
<template>
    <div id="Application" class="wrap">
        <div class="application">
            <div class="title">
                <h2>신입지원</h2>
            </div>  
            <div class="row">
                <!-- <div class="col-12 col-md-7"> -->
                    <div class="textbox">
                        <h4>지원내역</h4>
                        <table>
                            <tbody>
                                <tr><th>(1) 메인 전시 공간 지원 (COSMO 40)</th></tr>
                                <tr><th>(2) 프로젝트 등 필요한 장비 지원</th></tr>
                                <tr><th>(3) 미디어 관련 기술 자문 지원</th></tr>
                                <tr><th>(4) 전시구성을 위한 부대비용 지원</th></tr>
                                <p> &nbsp;&nbsp; ㅡ &nbsp; 작가 : 각 20만원 (설치 및 철수 등 작품 운영비) </p><br>
                                <p> &nbsp;&nbsp; ㅡ &nbsp; 기획자 : 150만원 (홍보비, 인쇄비 등 포함) </p>
                                <tr><th>(5) 개인/팀 프로젝트 진행시 몰입형공간(2면/3면) 제공</th></tr>
                                <tr><th>(6) VERS의 차후 미디어 콘텐츠 프로젝트에 창작활동 기회 부여 (하단 이미지 참고)</th></tr>
                                <!-- <tr><th>(6) VERS의 차후 미디어 콘텐츠 프로젝트에 창작활동 기회 부여 <br> (좌측 이미지 참고)</th></tr> -->
                            </tbody>
                            <div class="img">
                                <img src="@/assets/image/패션해체.jpg">
                                <img src="@/assets/image/BC카드.jpg" style="margin-left:20px; margin-right:20px;">
                                <img src="@/assets/image/NY TimeSqure.jpg">
                            </div>
                        </table>
                    </div>
                    <div class="textbox">
                        <h4>지원방법</h4>
                        <table>
                            <tbody>
                                <tr><th>(1) 접수 기간 : 2021년 12월 15일 – 2022년 1월 12일</th></tr>
                                <tr><th>(2) 이메일 접수 : apply@vers.kr</th></tr>
                                <tr><th>(3) 이메일 제목 ‘[SEVS 15기 전시지원 공모] - (지원자 이름)’ 양식에 맞춰 제출</th></tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="textbox">
                        <h4>제출서류</h4>
                        <table>
                            <tbody>
                                <tr><th>(1) 지원신청서 및 개인정보 수집·이용 동의서(공통) : 양식 다운로드, 작성 및 제출</th></tr>
                                <tr><th>(2) 포트폴리오(공통) : 자유 양식으로 100mb 이하의 본인의 활동 포트폴리오</th></tr>
                                <h5> &nbsp; - &nbsp; 자세한 내용은 <span>&nbsp;공고문</span> 을 통해 확인하시기 바랍니다.</h5>
                            </tbody>
                        </table>
                    </div>
            </div>  
         <!-- 파일 vers 호스팅으로 업로드 -->
            <p  style="font-weight:500; font-size:1.5rem; padding-left:15px">지원서류 다운로드</p>
            <ul class="list">
                <li>
                    <div class="imgbox">
                        <img src="../assets/icon/document (1).png" style="width: 40%;">
                        <!-- <p style="margin-left:10px">접수중</p> -->
                    </div>
                    <div class="txtbox">
                        <p class="txt"> 2022년 SEVS 15th 미디어아티스트 전시지원 프로그램 공모문 </p>
                    </div>
                    <div class="link">
                        <a href="http://vers.kr/sevs/[공고문]SEVS 15th 미디어아티스트 및 기획자 전시지원 프로그램 공모.pdf" download>다운로드</a>
                    </div>
                </li>
                <li>
                    <div class="imgbox">
                        <img src="../assets/icon/free-icon-technical-drawing-1321042.png" style="width: 40%;">
                        <!-- <p style="margin-left:10px">접수중</p> -->
                    </div>
                    <div class="txtbox">
                        <p class="txt"> 전시장 도면 </p>
                    </div>
                    <div class="link">
                        <a href="http://vers.kr/sevs/cosmo40 도면.zip" download>다운로드</a>
                    </div>
                </li>
                <li>
                    <div class="imgbox">
                        <img src="../assets/icon/document.png" style="width: 40%;">
                        <!-- <p style="margin-left:10px">접수중</p> -->
                    </div>
                    <div class="txtbox">
                        <p class="txt">SEVS 15th 전시지원 프로그램 지원서 (작가용) </p>
                    </div>
                    <div class="link">
                        <a href="http://vers.kr/sevs/SEVS15기_지원서_작가.hwp" download>다운로드</a>
                    </div>
                </li>
                <li>
                    <div class="imgbox">
                        <img src="../assets/icon/contract.png" style="width: 40%;">
                        <!-- <p style="margin-left:10px">접수중</p> -->
                    </div>
                    <div class="txtbox">
                        <p class="txt"> SEVS 15th 전시지원 프로그램 지원서 (기획자용) </p>
                    </div>
                    <div class="link">
                        <a href="http://vers.kr/sevs/SEVS15기_지원서_기획자.hwp" download>다운로드</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss">
#Application {
    .application{height: 100%;
        .title{margin: 90px 0 0 0; }
        .list{ margin-top: 3%; margin-bottom: 10%;
            li {width: 100%; padding: 24px 30px; border-bottom: 1px solid #e5e5e5; 
                .imgbox{width: 10%; float: left;}
                .txtbox{font-size: 0; width: 80%; line-height: 45px; float: left;}
                    .txt{display: inline-block; font-size: 20px; font-weight: 400;}
                
                .link{display: inline-block; width: 10%; text-align: center; border-radius: 30px; border: 1px solid black; line-height: 50px;}
                .link a{color: black; font-weight: 500; font-size: 18px;}
            }
        }
	.row { padding-top: 5%;
        .textbox{line-height: 2.1; text-align: left; margin-bottom: 5%;
            h4{font-weight: 500;}
            table{margin: 1.3%; font-size: 20px;}
            h5{font-weight: 300; margin-top: 3%;}
            span{color:#fb4343; font-size: 25px; font-weight: 600;}
            p{font-size: 18px;}
                
       .img{ margin-top: 5%;
            img{width: 32%; height: 270px; overflow: hidden; float: left; } 
            }
        }
    }
}    
    h2{display: inline; margin: 0 20px 0 5px;}
    p{display: inline; font-weight: 500; font-size:18pt;}
}


@media ( max-width: 1023px ) {
    #Application {
        .application{padding-bottom: 60px; padding-left: 15px; padding-right: 15px;
            .title{margin-top: 10px; 
                h2{font-size: 28px; margin: 0;}
            }
            .list{ margin-top: 9%; margin-bottom: 2%;
                li {width: 100%; padding: 24px 7px; padding-bottom: 50px; border-bottom: 1px solid #e5e5e5; 
                    .imgbox{width: 15%; float: left; display: none;}
                    .txtbox{font-size: 0; width: 60%; line-height: 30px; float: left; margin-right: 40px;
                        .txt{display: inline-block; font-size: 13px; font-weight: 400;}
                    }
                    .link{display: inline-block; width: 25%; text-align: center; border-radius: 30px; border: 1px solid black; line-height: 40px;}
                    .link a{color: black; font-weight: 500; font-size: 13px;}
                }
            }
            .row { padding-top: 10%;
                .textbox{ padding: 0;
                    table{margin:10px 0px 10px 0px;}
                    tr{font-size: 16.5px;}
                    p{font-size: 0.9rem;}
                    h5{font-size: 13px;}
                    .img{
                        img{width: 29%; height: 70px; float: left; overflow: hidden;}
                    }
                }
            }
        }
    }
}
</style>